/**
 * Config: Timings
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for timing durations.
 * - Automatically generated by `design` command, do not edit.
 *
 */
// eslint-disable

export const values = {
  snappy: 0.2,
  quick: 0.15,
  normal: 0.3,
  slow: 0.8,
  message: 3,
}

export default {
  snappy: values.snappy * 1000,
  quick: values.quick * 1000,
  normal: values.normal * 1000,
  slow: values.slow * 1000,
  message: values.message * 1000,
}
